import React, {useId} from 'react';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';
import styles from './Tooltip2.module.css';

interface Props {
  text: string;
  children: React.ReactNode;
  showIcon?: boolean;
  hidden?: boolean;
}

const Tooltip2 = ({
  text,
  children,
  showIcon = false,
  hidden = false,
}: Props) => {
  const id = useId();
  const renderTooltip = (props: any) => (
    <Tooltip id={id} className={styles.tooltip} {...props}>
      {text}
    </Tooltip>
  );

  if (hidden) {
    return <>{children}</>;
  }

  if (showIcon) {
    return (
      <span className={styles.tootlipContainer}>
        {children}
        <OverlayTrigger
          placement="auto"
          overlay={renderTooltip}
          delay={{show: 200, hide: 0}}
          containerPadding={10}>
          <span className={styles.icon}>?</span>
        </OverlayTrigger>
      </span>
    );
  }

  return (
    <OverlayTrigger
      placement="auto"
      overlay={renderTooltip}
      delay={{show: 200, hide: 100}}
      flip={true}
      containerPadding={10}>
      <span className={styles.tootlipContainer}>{children}</span>
    </OverlayTrigger>
  );
};

export default Tooltip2;
